import type { MouseEvent } from "react";
import classNames from "classnames";
import type { IconType } from "@circle-react-shared/Icon";
import { Box } from "./Box";

export interface ListItem {
  description?: string;
  icon?: { selected: IconType; default: IconType; viewBox: string };
  label?: string;
  multi?: boolean;
  name: string;
}

export interface BoxSelectComponentProps {
  direction: "horizontal" | "vertical";
  list: ListItem[];
  onChange?: (value: string[]) => void;
  value: string[];
}

export const BoxSelectComponent = ({
  value = [],
  onChange,
  direction,
  list = [],
}: BoxSelectComponentProps) => {
  const singleValues = list.filter(item => !item.multi).map(item => item.name);

  const handleClick = (
    itemName: string,
    multi: boolean,
    event: MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
    let newValue = value;
    if (value.includes(itemName)) {
      if (multi && value.length > 1) {
        newValue = value.filter(v => v !== itemName);
      }
    } else {
      if (multi) {
        newValue = [
          ...value.filter(item => !singleValues.includes(item)),
          itemName,
        ];
      } else {
        newValue = [itemName];
      }
    }
    onChange && onChange(newValue);
  };

  const boxList = list.map(item => (
    <Box {...item} key={item.name} handleClick={handleClick} value={value} />
  ));

  return (
    <div className={classNames("react-checkbox__boxes", direction)}>
      {boxList}
    </div>
  );
};
